$(document).ready(function(e) {
	
	$('.thumbnail').click(function(e) {
		$(this).hide();
		$('#myVdo').show().get(0).play();
	});
	
	$('.thumbnail1').click(function(e) {
		$(this).hide();
		$('#myVdo1').show().get(0).play();
	});
	
	$('.thumbnail2').click(function(e) {
		$(this).hide();
		$('#myVdo2').show().get(0).play();
	});
	
	$('.thumbnail3').click(function(e) {
		$(this).hide();
		$('#myVdo3').show().get(0).play();
	});
	
	$('.thumbnail4').click(function(e) {
		$(this).hide();
		$('#myVdo4').show().get(0).play();
	});
	
	$('.package_slider').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: true,
		fade: false,
		asNavFor: '.package_slider_nav',
		autoplay: false,
		autoplaySpeed: 11000,
		dots: false,
		responsive: [
		{
			breakpoint: 767,
			settings: {
				slidesToShow:1,
				slidesToScroll: 1,
				dots: false,
				centerMode: false,
				variableWidth: false,
				arrows: true,
			}
		}
		]
	});

	$('.package_slider_nav').slick({
		slidesToShow:5,
		slidesToScroll: 1,
		asNavFor: '.package_slider',
		dots: false,
		centerMode: false,
		focusOnSelect: true,
		infinite: true,
		arrows: false,
		rtl: false,
	});
	
	
	$('.s5_slider').slick({
		dots: false,
		slidesToShow: 3,
		slidesToScroll: 1,				
		arrows: true,
		responsive: [
		
		{
			breakpoint: 1021,
			settings: {
				slidesToShow:2,
			}
		},
		{
			breakpoint: 767,
			settings: {
				slidesToShow:1,
				arrows: true,
				dots: true,
			}
		}
		]
	}); 
	
	$('.s1_game_block').slick({
		dots: false,
		slidesToShow: 3,
		slidesToScroll: 1,				
		autoplaySpeed:4000,
		arrows: false,
		responsive: [
		{
			breakpoint: 9999,
			settings: "unslick"
		},
		
		{
			breakpoint: 767,
			settings: {
				slidesToShow:1,
				variableWidth: true,
				centerMode: true,
				dots: true,
				arrows: true,
			}
		}
		]
	});
	
	$('.s4_block').slick({
		dots: false,
		slidesToShow: 4,
		slidesToScroll: 1,				
		autoplaySpeed:4000,
		arrows: false,
		responsive: [
		{
			breakpoint: 9999,
			settings: "unslick"
		},
		
		{
			breakpoint: 767,
			settings: {
				slidesToShow:1,
				variableWidth: true,
				dots: true,
			}
		}
		]
	}); 
	
	
	$(".btn_scorall").click(function() {
		$('html, body').animate({
			scrollTop: $("#getOrder").offset().top - 65
		}, 2000);
	});
	
	//accordion JS 
	$(".acdn-heading").click(function() {
		
		var questionDiv = $(this);
		var answerDiv   = $(this).next('.acdn-content');
		var idx = $('.acdn-content').index(answerDiv);
		
		$('.acdn-content').each(function(index, ansDiv) {
			if(index != idx && $(ansDiv).is(':visible')) {
				$(ansDiv).slideUp(500, function() {
					$(ansDiv).prev('.acdn-heading').removeClass('accordion-open');
				});
			}
		});
					
		if (answerDiv.is(':visible')) {
			answerDiv.stop().slideUp(500, function() {
				questionDiv.removeClass('accordion-open');
			});
		} else {
		  questionDiv.addClass('accordion-open');
		  answerDiv.stop().slideDown(500);
		}
		
	});
	
});
	

$(document).scroll(function() {
		
	if ($(this).scrollTop() > 40){
		$('.top-fix-bar').addClass('fixed-nav');
	}else{
		$('.top-fix-bar').removeClass('fixed-nav');
	}
	
	
});
document.addEventListener('DOMContentLoaded', function() {
    var targetDiv = document.querySelector('div[data-disabled="false"][data-wzb="InformationBar"][zb-embed=""]');
    if (targetDiv) {
        targetDiv.style.display = 'none';  // Hide the div
    }
    // reset body tag
    document.body.removeAttribute('style');
});
